import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-admin-transactions',
    templateUrl: './admin-transactions.component.html',
    styleUrls: ['./admin-transactions.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdminTransactionsComponent {

}
